import useQueryOnce from 'hb-react/shared/hooks/useQueryOnce';
import { axiosInstance as axios } from 'hb-react/shared/utils/axios';

export const useQueryNationalities = () => {
  const { isLoading, data: asyncNationalityOptions } = useQueryOnce({
    queryKey: ['nationalities'],
    queryFn: () =>
      axios
        .get(Routes.search_nationalities_path({ format: 'json' }))
        .then(({ data }) => data),
  });

  return {
    data: asyncNationalityOptions,
    isLoading,
  };
};
